import React from 'react';

import './BusModifySearchCollapsed.css';
const months = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec'
];
const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

type BusModifySearchCollapsed = {
  sourceCityName: string;
  operatorName: string;
  destinationCityName?: string;
  setcollapsableFlag: React.Dispatch<React.SetStateAction<boolean>>;
};

const BusModifySearchCollapsed = ({
  sourceCityName,
  operatorName,
  destinationCityName,
  setcollapsableFlag
}: BusModifySearchCollapsed) => {
  const today = new Date();
  return (
    <div className="busModifySearchCollapsedWrap">
      <p className="font16 latoBold appendBottom5 whiteText">
        {' '}
        {(() => {
          if (operatorName && destinationCityName) {
            return `${sourceCityName} to ${destinationCityName} Buses`;
          }
          if (operatorName) {
            return `${operatorName} Buses`;
          }
          if (destinationCityName) {
            return `${sourceCityName} to ${destinationCityName} Buses`;
          } else {
            return `${sourceCityName} Buses`;
          }
        })()}
      </p>
      <p style={{ color: '#a7aebb' }} className="font12 appendBottom2">
        {' '}
        {`${days[today.getDay()]}, ${today.getDate()} ${
          months[today.getMonth()]
        } ${today.getFullYear() % 2000}  `}
      </p>
      <p title="Modify search for Buses" className="widgetSearchBtn--wrap">
        <button
          onClick={() => {
            setcollapsableFlag(false);
          }}
          className="bluePrimarybtn widgetSearchBtn"
        >
          {destinationCityName ? `Modify search` : `Search your route`}
        </button>
      </p>
    </div>
  );
};

export default BusModifySearchCollapsed;
